import { render } from "./ModuleCard.vue?vue&type=template&id=4ce85c9a&scoped=true&ts=true"
import script from "./ModuleCard.vue?vue&type=script&lang=ts"
export * from "./ModuleCard.vue?vue&type=script&lang=ts"

import "./ModuleCard.vue?vue&type=style&index=0&id=4ce85c9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce85c9a"]])

export default __exports__